import { Ref } from 'react';
import { ResponsiveValue } from 'styled-system';
import { Theme } from '@mos-cat/ds-theme';
import { SystemStyleObject } from '@styled-system/css';
import { As, forwardRefWithAs, PropsWithAs } from '../as';
import { Box, BoxProps } from '../Box/Box';

export type Space = BoxProps['p'];

/**
 * @public
 */
export type InlineProps = BoxProps & {
  space: Space;
  wrapper?: As;
};

/**
 * @public
 */
export const Inline = forwardRefWithAs<InlineProps, 'div'>(function Inline(
  {
    space = 'sp-0',
    children,
    wrapper = 'div',
    ...props
  }: PropsWithAs<InlineProps, 'div'>,
  ref: Ref<HTMLDivElement>
): JSX.Element {
  const negativeMargin = (Array.isArray(space)
    ? space.map((s) => {
        let result;
        if (typeof s === 'string' || typeof s === 'number') {
          result = `-${s}`;
        } else {
          result = null;
        }
        return result;
      })
    : `-${String(space)}`) as ResponsiveValue<keyof Theme['space']>;
  return (
    <Box {...props} ref={ref}>
      <Box
        alignItems={props.alignItems}
        as={wrapper}
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
        mt={negativeMargin}
        ml={negativeMargin}
        styles={
          {
            '& > *': {
              marginLeft: space,
              marginTop: space,
            },
          } as SystemStyleObject
        }
      >
        {children}
      </Box>
    </Box>
  );
});
